module.exports = __webpack_public_path__ + "static/img/filter.22706ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/filter.png
// module id = 7nXe
// module chunks = 1